var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M10.45.456a.367.367 0 0 0-.03.033L5.212 7.127l-3.14-3.141a1.125 1.125 0 0 0-1.59 1.59l3.97 3.97a1.125 1.125 0 0 0 1.618-.03l5.988-7.485A1.125 1.125 0 0 0 10.451.456z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertCheck);
export default __webpack_public_path__ + "static/media/expert_check.b5680d53e9e2b7e0ea95352e44b65a39.svg";
export { ForwardRef as ReactComponent };